export const getChangeCarac =
  (setValues, setStepStatus) => (e, value, action) => {
    e.preventDefault();
    setValues(prev => ({
      ...prev,
      characteristics: {
        ...prev.characteristics,
        [value]:
          action === 'add'
            ? prev.characteristics[value] + 1
            : prev.characteristics[value] > 0
            ? prev.characteristics[value] - 1
            : 0
      }
    }));

    setStepStatus(prev => ({
      ...prev,
      characteristics: {
        ...prev.characteristics,
        [value]:
          action === 'add'
            ? prev.characteristics[value] + 1
            : prev.characteristics[value] > 0
            ? prev.characteristics[value] - 1
            : 0
      }
    }));
  };

export const getChangeCaracObj =
  (setValues, setStepStatus) => (path, value) => {
    const pathArr = ['characteristics', ...path.split('.')];

    setValues(prev => {
      const newData = { ...prev };
      let current = newData;

      pathArr.forEach((key, index) => {
        if (index === pathArr.length - 1) {
          current[key] = value;
        } else {
          if (!current[key]) current[key] = {};
          current = current[key];
        }
      });

      return newData;
    });

    setStepStatus(prev => {
      const newData = { ...prev };
      let current = newData;

      pathArr.forEach((key, index) => {
        if (index === pathArr.length - 1) {
          current[key] = value;
        } else {
          if (!current[key]) current[key] = {};
          current = current[key];
        }
      });

      return newData;
    });
  };
